import { popular } from 'components/pages/static/content/faq'
import { FAQQuestions } from 'components/shared/FAQQuestions'
import { MetaHead } from 'components/shared/MetaHead'
import { Box } from 'components/ui/Box'
import { Breadcrumbs } from 'components/ui/Breadcrumbs'
import { Container } from 'components/ui/Container'
import { Typography } from 'components/ui/Typography'
import useTranslation from 'next-translate/useTranslation'
import { FC, useState } from 'react'
import { useTheme } from 'styled-components'

import { Categories, CategoryItem, Content, Wrapper } from './styles'

export const FAQPage: FC = () => {
  const theme = useTheme()
  const { t, lang } = useTranslation('staticPages')
  const [activeCategoryId, setActiveCategoryId] = useState(1)

  const breadcrumbs = [
    {
      url: '/',
      label: t('breadcrumbs.home'),
    },
    {
      url: '/faq',
      label: t('breadcrumbs.faq'),
    },
  ]

  const categories = [
    {
      id: 1,
      title: t('faq.popularQuestions'),
      questions: popular[lang],
    },
  ]

  const activeCategory =
    categories.find(category => category.id === activeCategoryId) || categories[0]

  return (
    <Wrapper>
      <MetaHead page='faq' />
      <Container>
        <Box marginTop={32}>
          <Breadcrumbs links={breadcrumbs} />
        </Box>
        <Box marginTop={24}>
          <Typography as='h1' typography={theme.typography.variants.title.H1}>
            {t('faq.title')}
          </Typography>
        </Box>
        <Content>
          <Categories>
            {categories.map(category => (
              <CategoryItem
                data-testid='category'
                key={category.id}
                onClick={() => setActiveCategoryId(category.id)}
              >
                <Typography
                  typography={theme.typography.variants.content.BOLD}
                  color={theme.palette.secondary.MAIN}
                >
                  {t('faq.popularQuestions')}
                </Typography>
              </CategoryItem>
            ))}
          </Categories>
          <FAQQuestions questions={activeCategory.questions} title={activeCategory.title} />
        </Content>
      </Container>
    </Wrapper>
  )
}
